import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Accordion from 'aquilla/core/molecules/Accordion';
import React, { forwardRef } from 'react';
import useCompeteInfo from '../useCompeteInfo';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_16B};
  margin-bottom: 350px;

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const StyledAccordion = styled(Accordion)`
  border: none;
  margin-top: ${Spacings.SPACING_6B};
  padding: 0;
  background-color: var(--color-i-base-0);

  & .accordion-description.expanded {
    padding-top: ${Spacings.SPACING_2B};
    color: var(--color-text-secondary);
  }
  &::-webkit-scrollbar {
    display: none;
  }
  &:hover {
    background: none;
  }

  & .accordion-header-action-icon {
    color: var(--color-text-secondary);
  }
`;

const SubTitle = styled.div`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: 20px;
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.P2};
    line-height: 16px;
  }
`;

const FAQsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FAQs = forwardRef((_, ref) => {
  const { faqs } = useCompeteInfo();
  const isMobile = useIsMobile();
  if (!faqs) {
    return null;
  }

  return (
    <>
      <Wrapper ref={ref}>
        <Typography variant={isMobile ? 'h5' : 'h4'}>
          Frequently asked questions
        </Typography>
        <SubTitle>Read through the recently asked questions</SubTitle>
        <FAQsWrapper>
          {faqs?.map(({ uid, question, answer }) => {
            return (
              <StyledAccordion
                key={uid}
                title={
                  <Typography variant={isMobile ? 'h6' : 'h5'}>
                    {question}
                  </Typography>
                }
              >
                {answer}
              </StyledAccordion>
            );
          })}
        </FAQsWrapper>
      </Wrapper>
    </>
  );
});

FAQs.displayName = 'FAQs';
export default React.memo(FAQs);
